import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import api from "../../lib/api";

export default function Schedules() {
    const [nfl, setNfl] = useState({ events: [], week: null });
    const [cfb, setCfb] = useState({ events: [] });
    useEffect(() => {
        api.get("/football/nfl/scoreboard").then(r => setNfl(r.data)).catch(() => {});
        api.get("/football/college/scoreboard").then(r => setCfb(r.data)).catch(() => {});
    }, []);

    const grid = (events, testid) => (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid={testid}>
            {events.map(e => (
                <div key={e.id} className="surface p-4">
                    <div className="text-[10px] uppercase tracking-widest text-white/40 mb-3 flex justify-between">
                        <span>{e.status}</span>
                        <span>{e.date && new Date(e.date).toLocaleDateString()}</span>
                    </div>
                    {e.teams.map(t => (
                        <div key={t.id} className="flex items-center gap-3 py-1">
                            {t.logo && <img src={t.logo} alt="" className="w-6 h-6" />}
                            <div className="flex-1 text-white text-sm truncate">{t.name}</div>
                            <div className="font-mono text-white/70">{t.score || "—"}</div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );

    return (
        <PageLayout>
            <section className="pt-28 pb-10 border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Football 365 · Schedules & Scores</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-none tracking-tight" data-testid="schedules-heading">
                        THE <span className="text-[#d4af37]">SLATE.</span>
                    </h1>
                </div>
            </section>
            <TrendingBar />

            <section className="py-10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 space-y-10">
                    <div>
                        <div className="flex justify-between items-end mb-4">
                            <h2 className="font-display text-3xl text-white">NFL · Week {nfl.week}</h2>
                            <Link to="/football/nfl" className="btn-ghost text-xs">Full NFL hub →</Link>
                        </div>
                        {grid(nfl.events, "sched-nfl")}
                    </div>
                    <div>
                        <div className="flex justify-between items-end mb-4">
                            <h2 className="font-display text-3xl text-white">College Football</h2>
                            <Link to="/football/college" className="btn-ghost text-xs">Full College hub →</Link>
                        </div>
                        {grid(cfb.events.slice(0, 12), "sched-cfb")}
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
